// extracted by mini-css-extract-plugin
module.exports = {"nav":"_3fBZbEEEFFHC9Am9AZTGJV"};